export const MOBILE_PIXEL_WIDTH = 768

export const EN = 'en'
export const FR = 'fr'

export const DATE_FORMAT = 'yyyy-MM-dd'
